export default __webpack_public_path__ + "static/media/component_template.f0863f28.xlsx";